import { inject, Service } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DialogService } from '@shared/components/dialog/dialog.service';

/**
 * The single "your edits will be lost" prompt. Shared by `unsavedChangesGuard`
 * and by the dialogs and drawers that close without a route change.
 */
@Service()
export class UnsavedChangesService {
  private readonly dialogService = inject(DialogService);
  private readonly translateService = inject(TranslateService);

  /** Emits `true` when the user chose to discard the edits, `false` to stay. */
  confirmDiscard$(): Observable<boolean> {
    return this.dialogService
      .confirmDialog({
        headerText: this.translate('SHARED.UNSAVED_CHANGES.TITLE'),
        contentText: this.translate('SHARED.UNSAVED_CHANGES.TEXT'),
        confirmBtnText: this.translate('SHARED.UNSAVED_CHANGES.LEAVE_BTN'),
        cancelBtnText: this.translate('SHARED.UNSAVED_CHANGES.STAY_BTN'),
      })
      .afterClosed()
      .pipe(map(result => result === true));
  }

  private translate(key: string): string {
    return this.translateService.instant(key) as string;
  }
}
